<template>
  <div class="look_shop">
    <img src="./../../assets/img/look_shop/1.png" alt="">
    <img src="./../../assets/img/look_shop/2.png" alt="">
    <looknum-box :lookNumData="lookNumData" :bgColor="bgColor"></looknum-box>
    <img src="./../../assets/img/look_shop/3.png" alt="">
    <img src="./../../assets/img/look_shop/10.png" alt="">
    <img src="./../../assets/img/look_shop/7.png" alt="">
    <img src="./../../assets/img/look_shop/8.png" alt="">
    <data-form pageId="1" :bgColor="bgColor" :formCol="formCol"></data-form>
    <img src="./../../assets/img/look_shop/9.png" alt="">
  </div>
</template>

<script>

export default {
  name: 'index',
  data () {
    return {
      lookNumData: [ /* 显示数据 */
        {
          name: '已托管铺源达',
          num: 78892,
          countFun: ''
        },
        {
          name: '已交诚意金租户达',
          num: 78892,
          countFun: ''
        }
      ],
      bgColor: '#2c3d77', /* 猪色值 */
      formCol: {
        popData: {
          name: '感谢您的报名，客服会尽快与您联系，为您匹配租户',
          colorOne: 'rgb(60,81,152)',
          colorTwo: 'rgb(44,61,119)'
        }
      }

    }
  },

  mounted () {
    // this.$post(this.$api.wxApi, {url:location.href.split('#')[0]}).then((res) => {
    //   wx.config({
    //     debug:true, /// /生产环境需要关闭debug模式
    //     appId: res.data.appid, // appId通过微信服务号后台查看
    //     timestamp: res.data.timestamp, // 生成签名的时间戳
    //     nonceStr: res.data.noncestr, // 生成签名的随机字符串
    //     signature: res.data.signature, // 签名
    //     jsApiList: [// 需要调用的JS接口列表
    //       'onMenuShareTimeline', // 分享给好友
    //       'onMenuShareAppMessage'// 分享到朋友圈
    //     ]
    //   })
    //   wx.ready(function () {
    //     let shareData = {
    //       title: '商铺空置、租金低？找商旺宝，海量品牌租户免费配',	//	标题
    //       link: `${this.$config.webUrl}/20191129`,	//	分享的URL，必须和当前打开的网页的URL是一样的
    //       imgUrl: 'https://swb-bucket01.oss-cn-zhangjiakou.aliyuncs.com/swb/prod/leading/marketing/share1.png'//	缩略图地址
    //     }
    //     // 分享朋友圈
    //     wx.onMenuShareAppMessage(shareData)
    //     wx.onMenuShareTimeline(shareData)
    //
    //     wx.error(function (res) {
    //       alert(res.errMsg)
    //     })
    //   })
    // })

    this.$get(this.$api.countNumApi).then((res) => {
      console.log(res)
      res.data.forEach((item) => {
        item.type == 1 ? this.lookNumData[0].num = item.countNumber : ''
        item.type == 2 ? this.lookNumData[1].num = item.countNumber : ''
      })
    })
  },
  methods: {

  }
}
</script>

<style lang="scss">
  .look_shop {
    background: #fff;

    img {
      width: 750px;
    }
  }

</style>



// WEBPACK FOOTER //
// src/views/look_shop/index.vue